import { useMemo } from 'react';

const STAFF_ROLES = new Set(['owner', 'admin', 'technician']);

/** Assignee dropdown for tasks: Unassigned, Me, then members (staff first, then portal users). */
export default function TaskAssigneeSelect({
  value, members, myId, onChange, disabled, className,
}: {
  value: string;
  /** Company member rows ({ user, role }) — customers included; they can hold tasks. */
  members: any[];
  myId?: string | null;
  onChange: (v: string) => void;
  disabled?: boolean;
  className?: string;
}) {
  const sorted = useMemo(() => {
    const rows = (members ?? []).filter((m: any) => m.user?.id);
    return rows.sort((a: any, b: any) => {
      const sa = STAFF_ROLES.has(a.role) ? 0 : 1;
      const sb = STAFF_ROLES.has(b.role) ? 0 : 1;
      return sa - sb || String(a.user.name ?? a.user.email).localeCompare(String(b.user.name ?? b.user.email));
    });
  }, [members]);
  return (
    <select
      className={className ?? 'select text-xs py-1'}
      value={value}
      disabled={disabled}
      onChange={e => onChange(e.target.value)}
      aria-label="Assignee"
    >
      <option value="">Unassigned</option>
      {myId && <option value={myId}>Me</option>}
      {sorted.filter((m: any) => m.user.id !== myId).map((m: any) => (
        <option key={m.user.id} value={m.user.id}>
          {m.user.name || m.user.email}{STAFF_ROLES.has(m.role) ? '' : ' (portal)'}
        </option>
      ))}
    </select>
  );
}
